import { eTaxType } from '../../../ui-toolkit/enums/eTaxType';

export default function generateTaxTypeOptions() {
  return Object.entries({
    /*tslint:disable:object-literal-sort-keys*/
    Mortgage: eTaxType.mortgage,
    Deed: eTaxType.deed,
    Excise: eTaxType.excise,
    /*tslint:enable:object-literal-sort-keys*/
  }).map((entry) => ({ label: entry[0], value: entry[1] }));
}
